package com.example.mystybag.biometricUtils.expected

import com.example.mystybag.biometricUtils.helpers.BiometricAuthenticationType
import com.example.mystybag.biometricUtils.helpers.BiometricErrorResult
import com.example.mystybag.core.expected.Activity

actual object BiometricsHandler {
    actual fun isBiometricScannerAvailableAndSet(): Boolean = false
    actual fun newBiometricEnrolled(): Boolean = false
    actual fun getAuthenticationType(): BiometricAuthenticationType = BiometricAuthenticationType.NONE
    actual fun initializeBiometrics(activity: Activity, onSuccess: () -> Unit, onFailed: (BiometricErrorResult) -> Unit) {}
    actual fun startBiometricAuthentication(activity: Activity, onSuccess: () -> Unit, onFailed: (BiometricErrorResult) -> Unit): Boolean = false
    actual fun stopListening() {}
    actual fun startSettingBiometricAuthentication(activity: Activity, onSuccess: () -> Unit, onFailed: (BiometricErrorResult) -> Unit) {}
    actual fun storeFinalKey() {}
    actual fun deleteKeyFromKeyStore(keyName: String) {}
    actual fun migrateBiometrics() {}
    actual fun removeAppGroupBioPolicyDomain() {}
}
